import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  DateRangeArrowStyled,
  DateRangeFieldsStyled,
  DateRangeInputStyled,
  DateRangeLabelStyled,
} from '../SeasonalRuleAddEditModal.styles';
import { SeasonalRuleFormValues } from '../SeasonalRuleAddEditModal.types';

const DateRangeField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<SeasonalRuleFormValues>();
  const startDate = useWatch({ control, name: 'startDate' });

  return (
    <div>
      <DateRangeLabelStyled $isRequired>
        {t('pageProperty.seasonality.modal.fields.dateRange.label')}
      </DateRangeLabelStyled>
      <DateRangeFieldsStyled>
        <DateRangeInputStyled>
          <DateTimePickerField
            name="startDate"
            data-testid="seasonal-rule-start-date"
            colSmInput={12}
            colSmLabel={0}
            required
          />
        </DateRangeInputStyled>
        <DateRangeArrowStyled aria-hidden>→</DateRangeArrowStyled>
        <DateRangeInputStyled>
          <DateTimePickerField
            name="endDate"
            data-testid="seasonal-rule-end-date"
            minDate={startDate ?? undefined}
            colSmInput={12}
            colSmLabel={0}
            required
          />
        </DateRangeInputStyled>
      </DateRangeFieldsStyled>
    </div>
  );
};

export default DateRangeField;
